// extracted by mini-css-extract-plugin
module.exports = {"gsapDText1":"gsapDText1_gsapDText1__HFdHi"};